import { openTimesheetPostingModal } from '../State/timesheetPostingModal'

export default () => (dispatch) => {

  dispatch(openTimesheetPostingModal())
  
}
